import { normalize } from '../../utils/text.js'
import { NewCMSEventContext, NewCMSParams, NewCMSRouteEvents } from './index.js'

export function slash(p: string) {
  if (!p) return '/'
  return p.startsWith('/') ? p : `/${p}`
}

export function join(base: string, seg: string) {
  if (!base || base === '/') base = ''
  if (!seg) return base || '/'
  const a = base.endsWith('/') ? base.slice(0, -1) : base
  const b = seg.startsWith('/') ? seg : `/${seg}`
  return a + b || '/'
}

export function idFrom(id: string | undefined, title: string) {
  return normalize(id ?? title)
}

export function paramsBag(obj: Record<string, string>): NewCMSParams {
  const frozen = Object.freeze({ ...obj })

  const api = {
    get: (k: string) => frozen[k],
    has: (k: string) => Object.prototype.hasOwnProperty.call(frozen, k),
  }

  return new Proxy(api as any, {
    get(target, prop) {
      if (typeof prop === 'string')
        return prop in target ? target[prop] : frozen[prop]
      return target[prop as any]
    },
    ownKeys() {
      return Reflect.ownKeys(frozen)
    },
    getOwnPropertyDescriptor(_, prop) {
      if (typeof prop === 'string' && prop in frozen) {
        return { enumerable: true, configurable: true }
      }
      return undefined
    },
  }) as NewCMSParams
}

export function sanitizeParams(input: any): Record<string, string> {
  const out: Record<string, string> = {}
  if (!input) return out
  for (const k of Object.keys(input)) {
    if (k === '*') continue
    if (/^\d+$/.test(k)) continue
    const v = input[k]
    if (typeof v === 'string') out[k] = v
  }
  return out
}

export function normalizeDot(target: string) {
  return target
    .split('.')
    .map((x) => normalize(x.trim()))
    .filter(Boolean)
    .join('.')
}

export function stripParamsPath(p: string) {
  const i = p.indexOf('/:')
  return i === -1 ? p : p.slice(0, i)
}

export function fire(
  on: NewCMSRouteEvents | undefined,
  name: keyof NewCMSRouteEvents,
  ctx: NewCMSEventContext,
) {
  const fn = on?.[name]
  if (fn) fn(ctx)
}
